/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { Grid, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { IErrorProps } from "../../models";
import GetToastErrorMessages from "./GetToastErrorMeessages";

interface IToastBarForErrorProps {
  open: boolean;
  onClose(): void;
  errorList: Array<IErrorProps>;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function ToastBarForError(props: IToastBarForErrorProps) {
  const [toastMessages, setToastMessages] = useState(
    GetToastErrorMessages(props.errorList)
  );

  return (
    <Snackbar
      open={props.open}
      autoHideDuration={4000}
      onClose={props.onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      {toastMessages && (
        <Grid>
          {toastMessages.map((message: string, index) => (
            <Alert
              id={message}
              key={message}
              onClose={() =>
                setToastMessages(toastMessages.filter((x) => x !== message))
              }
              severity="info"
              sx={{
                width: "100%",
                minWidth: "500px",
                backgroundColor: "#F0F0F0",
                color: "#303030",
                marginBottom: "10px",
              }}
            >
              {message}
            </Alert>
          ))}
        </Grid>
      )}
    </Snackbar>
  );
}
